import { render, staticRenderFns } from "./CommunityHappinessOperationRankingEmployeesNumber.vue?vue&type=template&id=80ff1ab8&scoped=true&"
import script from "./CommunityHappinessOperationRankingEmployeesNumber.vue?vue&type=script&lang=js&"
export * from "./CommunityHappinessOperationRankingEmployeesNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ff1ab8",
  null
  
)

export default component.exports